import script from "./GroupsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsTable.vue?vue&type=script&setup=true&lang=js"

import "./GroupsTable.vue?vue&type=style&index=0&id=1384e885&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1384e885"]])

export default __exports__